import Vue from 'vue';
import Meta from 'vue-meta'
import Router from 'vue-router'
import routes from './routes'
import store from '../store.js';


import '../mixins/generalMixin';

Vue.use(Meta);
Vue.use(Router);

const router = createRouter();
function createRouter () {
    const router = new Router({
        mode: 'history',
        routes
    });
    router.beforeEach(beforeEach);
    router.afterEach(afterEach);
    return router
}
async function beforeEach (to, from, next) {
    if (to == "") {
        return next();
    }
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    await store.dispatch("user/logInfo", "beforeEach");
    if(requiresAuth)
    {
        if(store.getters['user/hostname'] != "") {
            await store.dispatch('user/fetchHostname');
        }
        await store.dispatch('user/fetchUser');
        next()
    }
    else next()
}
async function afterEach (to, from, next) {
    if (to == "") {
        return next();
    }
    await router.app.$nextTick()
}
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router;
